//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";
import moment from "moment";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { validateEmail } from "@/utils/validations.js";

export default {
  name: "SalesForceTab",
  props: ["value"],
  components: {},
  mounted: function () {
    BackendServices.getSalesforceHierarchyLevelElements().then((response) => {
      this.positionList = response.data;
    });
    BackendServices.getSalesforceEmployeeTypes().then((response) => {
      this.originList = response.data;
    });

    this.validateData();
  },
  data: () => ({
    moment,
    positionList: [],
    originList: [],
    newRegistry: true,
    validForm: false,
  }),
  methods: {
    required,
    noValidation,
    validateEmail,
    deleteRecord: async function () {
      let response = await BackendServices.deleteSalesforceEmployee(this.value);
      this.$emit("change-tab", response.status);
    },
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData() {
      this.$emit("value", this.value);
    },
  },
  computed: {},
};
